import { Box, IconButton, Stack, Typography } from "@mui/material"
import LinkedInIcon from "@mui/icons-material/LinkedIn"
import Section from "./Section"

interface GuyProps {
  phone: boolean
  title: string
  img: string
  text: string
  linkedin: string
}
function Guy({ phone, title, img, text, linkedin }: GuyProps) {
  return (
    <Stack
      direction={phone ? "column" : "row"}
      justifyContent="center"
      alignItems="center"
      spacing={phone ? 1 : 3}
    >
      <Box
        sx={
          phone ? { alignSelf: "center", pt: 0 } : { alignSelf: "start", pt: 5 }
        }
      >
        <Box component="img" src={img} width="160px" borderRadius="12px" />
      </Box>
      <Stack maxWidth="400px" alignItems="center" sx={{ flex: 1 }}>
        <Stack direction="row" spacing={5} alignItems="center">
          <Typography variant="h6" fontWeight="bold">
            {title}
          </Typography>
          <IconButton
            onClick={(e) => {
              e.preventDefault()
              window.open(linkedin, "_blank")
            }}
          >
            <LinkedInIcon fontSize="large" color="primary" />
          </IconButton>
        </Stack>
        <Typography align="left" color="rgb(154, 167, 180)">
          {text}
        </Typography>
      </Stack>
    </Stack>
  )
}

function Gilles({ phone }: AboutProps) {
  return (
    <Guy
      phone={phone}
      title="Gilles - Informaticien"
      img="/gilles.jpg"
      text="Gilles a fait l’essentiel de sa carrière dans deux startups à succès,
          en France et au Canada. Son savoir faire technique lui a permis de
          construire un produit qui apporte des solutions efficaces et
          innovantes aux problèmes identifiés par Victor."
      linkedin="https://www.linkedin.com/in/gilles-desforges-4a54951/"
    />
  )
}

function Victor({ phone }: AboutProps) {
  return (
    <Guy
      phone={phone}
      title="Victor - Logisticien"
      img="/victor.jpg"
      text="Fort d'un dizaine d'années d'expérience dans les entrepôts, il a identifié des problèmes
      de performance récurrents. Après une analyse approfondie de ces problèmes, il a décidé d'y apporter une solution, et elle s'appelle WM-up !"
      linkedin="https://www.linkedin.com/in/victor-eonnet-65036134/"
    />
  )
}

export interface AboutProps {
  phone: boolean
}
export default function About({ phone }: AboutProps) {
  return (
    <Section>
      <Stack sx={{ width: "100%" }} alignItems="start">
        <Typography fontWeight="bold" fontSize={34} sx={{ p: 1 }}>
          L'équipe
        </Typography>

        <Stack
          direction={phone ? "column" : "row"}
          alignItems={phone ? "center" : "start"}
          spacing={7}
          sx={{ p: 1, width: "100%" }}
        >
          <Victor phone={phone} />
          <Gilles phone={phone} />
        </Stack>
      </Stack>
    </Section>
  )
}
